import { useCallback } from 'react';
import {
  activityUiHelpers,
  getActivityEntityDescriptor,
} from '@ayocore/activity/client/extensions';
import { normalizeActivityScope } from '../utils/normalize-activity-scope';
import type { ActivityChatItem } from '@ayocore/activity/common/types/activity-message';

type ActivityScope = ActivityChatItem['scope'];

/**
 * UI-действия для кликов по scope-меткам в чате активности.
 *
 * Диспетчеризация — через реестр дескрипторов сущностей по `entity_type`:
 * scope кликабелен, если модуль-владелец зарегистрировал `openEntity`.
 * Для незнакомых типов — graceful fallback (клик недоступен).
 */
export function useActivityScopeActions() {
  const isScopeClickable = useCallback((scope?: ActivityScope | null): boolean => {
    const normalized = normalizeActivityScope(scope);
    if (!normalized) return false;
    return Boolean(getActivityEntityDescriptor(normalized.entity_type)?.openEntity);
  }, []);

  const onScopeClick = useCallback(async (scope?: ActivityScope | null): Promise<void> => {
    const normalized = normalizeActivityScope(scope);
    if (!normalized) return;

    const openEntity = getActivityEntityDescriptor(normalized.entity_type)?.openEntity;
    if (!openEntity) return;

    await openEntity(
      {
        entity_type: normalized.entity_type,
        entity_uuid: normalized.entity_uuid,
        label: normalized.label ?? null,
      },
      activityUiHelpers
    );
  }, []);

  return {
    onScopeClick,
    isScopeClickable,
  };
}
